import * as supplierActions from '../../actions/supplier.actions';

const scoreOrderingLabel = $localize`:|score ordering label relevance @@ordering-value-range.reducer_score-ordering-label-relevance:Relevance`;

export const defaultOrderingValueRange: { label: string; value: string }[] = [
  {
    label: $localize`:|score ordering label recently updated @@ordering-value-range.reducer_score-ordering-label-recently-updated:Recently updated`,
    value: 'company_newest desc'
  },
  {
    label: $localize`:|score ordering label company name @@ordering-value-range.reducer_score-ordering-label-company-name:Supplier A-Z`,
    value: 'company_name'
  },
  {
    label: $localize`:|score ordering label company name desc @@ordering-value-range.reducer_score-ordering-label-company-name-desc:Supplier Z-A`,
    value: 'company_name desc'
  }
];

/**
 *
 * @param state the current state
 * @param action an action that may result in returning a new state
 * @returns the new state
 */
export const orderingValueRange = (
  state: { label: string; value: string }[] = defaultOrderingValueRange,
  action: supplierActions.Actions
): { label: string; value: string }[] => {
  switch (action.type) {
    case supplierActions.FETCH_MULTI_SUCCEEDED:
      if (action.payload.queryConfig.basic_filters && action.payload.queryConfig.basic_filters.find(filter => filter.id === 'search_string')) {
        const scoreOrdering = {
          label: scoreOrderingLabel,
          value: 'product_score desc'
        };
        return [...defaultOrderingValueRange, scoreOrdering];
      }
      return defaultOrderingValueRange;
    default:
      return state;
  }
};
